import styled from '@emotion/styled';
import React from 'react';
import { Container } from '../../components/container/Container';

interface IProps extends React.HTMLAttributes<HTMLElement> {
  isGray?: boolean;
  container?: boolean;
  paddingTop?: number;
  paddingBottom?: number;
  paddingTopMobile?: number;
  paddingBottomMobile?: number;
  mergeTop?: boolean;
  isArticle?: boolean;
}

interface SegmentProps {
  paddingTop?: number;
  paddingBottom?: number;
  paddingTopMobile?: number;
  paddingBottomMobile?: number;
  isGray?: boolean;
  spaceGutter: number;
}

const SegmentHost = styled.section<SegmentProps>`
  background-color: ${(props) => props.theme.colors.background};
  padding-top: ${(props) =>
    props.paddingTopMobile !== undefined
      ? props.paddingTopMobile
      : props.spaceGutter}px;
  padding-bottom: ${(props) =>
    props.paddingBottomMobile !== undefined
      ? props.paddingBottomMobile
      : props.spaceGutter}px;
  ${(props) =>
    props.isGray && `background-color: ${props.theme.colors.backgroundAlt}`};
  ${(props) => props.isGray && `margin-bottom: ${props.spaceGutter}px`};

  &:last-of-type {
    padding-bottom: ${(props) => props.spaceGutter * 2}px;
  }

  margin-top: -1px;
  margin-bottom: -1px;

  @media (min-width: ${(props) => props.theme.breakpoints.md.width}px) {
    padding-top: ${(props) =>
      props.paddingTop !== undefined
        ? (props.paddingTop / props.theme.pageLimit(props)) * 100
        : ((props.spaceGutter * 2) / props.theme.pageLimit(props)) * 100}%;
    padding-bottom: ${(props) =>
      props.paddingTop !== undefined && props.paddingBottom
        ? (props.paddingBottom / props.theme.pageLimit(props)) * 100
        : ((props.spaceGutter * 2) / props.theme.pageLimit(props)) * 100}%;
    ${(props) => props.isGray && `margin-bottom: ${props.spaceGutter * 2}px`};

    &:last-of-type {
      padding-bottom: ${(props) => props.spaceGutter * 3}px;
    }
  }

  @media (min-width: ${(props) => props.theme.pageLimit}px) {
    padding-top: ${(props) =>
      props.paddingTop !== undefined
        ? props.paddingTop
        : props.spaceGutter * 2}px;
    padding-bottom: ${(props) =>
      props.paddingBottom !== undefined
        ? props.paddingBottom
        : props.spaceGutter * 2}px;
    ${(props) => props.isGray && `margin-bottom: ${props.spaceGutter * 2}px`};
  }
`;

export const Segment = ({
  children,
  isGray,
  isArticle,
  container = true,
  paddingTop,
  paddingBottom,
  paddingBottomMobile,
  paddingTopMobile,
  ...rest
}: IProps) => {
  const spaceGutter = isArticle ? 18 : 36;

  return (
    <SegmentHost
      isGray={isGray}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      paddingBottomMobile={paddingBottomMobile}
      paddingTopMobile={paddingTopMobile}
      spaceGutter={spaceGutter}
      {...rest}
    >
      {container ? <Container>{children}</Container> : children}
    </SegmentHost>
  );
};
